import React, { FC, useEffect, useRef, useState } from 'react';
import { ApprovalHeaderCrpSelectProps } from './ApprovalHeaderCrpSelectProps';
import ListBox from '@ingka/list-box';
import ListView, { ListViewItem } from '@ingka/list-view';
import { getFY } from '../../utils/calculation';
import { returnCrpLabel, returnPillLabel } from './utils';
import SuitCase from '@ingka/ssr-icon/paths/briefcase';
import Button from '@ingka/button';
import { Stack } from '@mui/material';
const CRP_OPTIONS = [
  { value: 'all', label: 'All CRP Plans' },
  { value: getFY(1), label: returnCrpLabel(getFY(1)) },
  { value: getFY(2), label: returnCrpLabel(getFY(2)) },
  { value: getFY(3), label: returnCrpLabel(getFY(3)) },
  { value: 'noCrp', label: 'All projects' },
];

const ApprovalHeaderCrpSelect: FC<ApprovalHeaderCrpSelectProps> = ({
  selectedValues,
  onChange,
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [open, setOpen] = useState(false);

  const handleClickOpen = (e: React.MouseEvent) => {
    e.stopPropagation();
    setOpen((prev) => !prev);
  };

  const onOptionClicked = (e) => {
    if (e === 'all' || e === 'noCrp') {
      onChange([e]);
      return;
    }
    if (selectedValues.includes(e)) {
      const newValues = selectedValues.filter((value) => value !== e);
      onChange(newValues.length === 0 ? ['all'] : newValues);
      return;
    }
    if (
      selectedValues.length === 1 &&
      (selectedValues[0] === 'all' || selectedValues[0] === 'noCrp')
    ) {
      onChange([e]);
      return;
    }
    onChange([...selectedValues, e]);
  };
  useEffect(() => {
    if (!open) return;

    const handleClickOutside = (e: MouseEvent) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(e.target as Node)
      ) {
        setOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [open]);

  return (
    <Stack
      ref={containerRef}
      sx={{
        '.list-box': {
          left: '2px',
        },
      }}
    >
      <ListBox
        popupMode
        open={open}
        style={{ maxHeight: 'none', width: '24rem', left: '2px' }}
        containerRef={containerRef}
        trigger={
          <Button
            onClick={handleClickOpen}
            size={'small'}
            type="secondary"
            ssrIcon={SuitCase}
            iconPosition="leading"
          >
            <span
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 4,
                whiteSpace: 'nowrap',
              }}
            >
              {returnPillLabel(selectedValues)}
            </span>
          </Button>
        }
      >
        <ListView id={'CRP-select'} showDivider size="small">
          {CRP_OPTIONS.map((option) => (
            <ListViewItem
              key={option.value}
              inset
              title={option.label}
              control="checkbox"
              controlProps={{
                checked: selectedValues.includes(option.value),
                value: option.value,
                subtle: false,
              }}
              id={`${option}-${option}`}
              onChange={() => onOptionClicked(option.value)}
            />
          ))}
        </ListView>
      </ListBox>
    </Stack>
  );
};

export default ApprovalHeaderCrpSelect;
